import { apiFetch } from "./api";
import type { Page, SiteSetting } from "./types";
import { Setting } from "./types";

export interface ApiEnvelope<T> {
  message: string;
  details: T;
}

export const fetchNavPages = async (): Promise<Page[]> => {
  const data = await apiFetch<{ pages: Page[] }>("/api/public/pages");
  return data?.pages ?? [];
};

interface PublicSettingsResponse {
  settings: {
    updatedAt: string;
    data: {
      defaultIconStoragePath?: string | null;
      facebookUrl?: string | null;
      instagramUrl?: string | null;
      twitterUrl?: string | null;
    };
  };
}

/** Flattens the public settings document into the type/value pairs the UI uses. */
export const fetchSiteSettings = async (): Promise<SiteSetting[]> => {
  const data = await apiFetch<PublicSettingsResponse>("/api/public/settings");
  if (!data) {
    return [];
  }

  const { updatedAt, data: values } = data.settings;
  const pairs: [SiteSetting["type"], string | null | undefined][] = [
    [Setting.DEFAULT_ICON, values.defaultIconStoragePath],
    [Setting.FACEBOOK, values.facebookUrl],
    [Setting.INSTAGRAM, values.instagramUrl],
    [Setting.TWITTER, values.twitterUrl],
  ];

  return pairs
    .filter((entry): entry is [SiteSetting["type"], string] => !!entry[1])
    .map(([type, value]) => ({ type, updatedAt: new Date(updatedAt), value }));
};

export const getDefaultIcon = (settings: SiteSetting[]): string | undefined =>
  settings.find((it) => it.type === "DEFAULT_ICON")?.value;
